import ProhibitedItemImport from '../../components/layout/ITHeadquarters/prohibitedItemImport';

const ProhibitedItemImportPage = () => {
    return <ProhibitedItemImport />;
};

export default ProhibitedItemImportPage;
